import React, { useEffect, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { confirmQuitFlow } from 'src/utils';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import { Viewer, Worker, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
// import { Page, pdfjs } from 'react-pdf';
// import { Document } from 'react-pdf/dist/esm/entry.webpack';
dayjs.extend(customParseFormat);
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface TermAndConditionObserverProps {
  cancerStore?: CancerStore;
}

const emptyArr = [];

const TermAndConditionObserver = observer(
  ({ cancerStore }: TermAndConditionObserverProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    // const [numPages, setNumPages] = useState(null);
    // const [pageRender, setPageRender] = useState(emptyArr);
    // const [loadingPage, setLoadingPage] = useState(false);

    // function onDocumentLoadSuccess({ numPages }) {
    //   console.log('onDocumentLoadSuccess', numPages);
    //   setNumPages(numPages);
    //   if (numPages > 2) {
    //     setPageRender([0, 1]);
    //   } else {
    //     setPageRender([0]);
    //   }
    // }

    const _handleClose = () => {
      confirmQuitFlow(history);
    };

    // const _renderPages = () => {
    //   if (!pageRender || !pageRender.length) return <div />;
    //   let pages = [];
    //   for (let pageIndex of pageRender) {
    //     pages.push(<Page pageNumber={pageIndex + 1} key={pageIndex} />);
    //   }
    //   return pages;
    // };

    // const _loadMorePage = () => {
    //   if (!pageRender || pageRender.length >= numPages || loadingPage) return;
    //   console.log('Load More');
    //   setLoadingPage(true);
    //   const newPageRender = [...pageRender];
    //   newPageRender.push(newPageRender[newPageRender.length - 1] + 1);
    //   setPageRender(newPageRender);
    //   setTimeout(() => {
    //     setLoadingPage(false);
    //   }, 700);
    // };

    // const _handleScroll = (e) => {
    //   const target = e.target;
    //   if (
    //     Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <
    //     45
    //   ) {
    //     _loadMorePage();
    //   }
    // };

    return (
      <div className="screen-container bg-background">
        <Toolbar title={t('term_and_condition')} />
        <div
          className="max-w-md mx-auto screenScrollContainerWithoutButton"
          style={{ width: '100hh', overflowY: 'scroll', overflowX: 'scroll' }}
        >
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
            <Viewer
              defaultScale={SpecialZoomLevel.PageWidth}
              fileUrl={process.env.PUBLIC_URL + '/BaohiembenhungthuTnC.pdf'}
            />
          </Worker>
          {/* <Document
            file={process.env.PUBLIC_URL + '/BaohiembenhungthuTnC.pdf'}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<div />}
          >
            {_renderPages()}
          </Document> */}
        </div>
      </div>
    );
  }
);

const TermAndCondition = () => (
  <TermAndConditionObserver cancerStore={cancerStore} />
);
export default TermAndCondition;
